// Global IBCS navigation-menu visibility setting.
// Controls whether the top-level "IBCS" dropdown (Deployment Plans + Dynamic
// Engagement) is shown in the main nav. Stored in localStorage so it persists
// across sessions without a backend migration (mirrors mapLabelSetting.js).
// Toggled from Platform Management; the nav reacts live via the custom event.

export const IBCS_NAV_KEY = 'ibcs_nav_enabled';

// Fired on window whenever the setting changes so the nav can update live
// without a reload.
export const IBCS_NAV_EVENT = 'ibcs-nav-changed';

// Default OFF — the IBCS hub stays hidden until an operator explicitly enables
// it from Platform Management, keeping the default menu focused on TMPC.
export function isIbcsNavEnabled() {
  const v = localStorage.getItem(IBCS_NAV_KEY);
  return v === null ? false : v === 'true';
}

export function setIbcsNavEnabled(enabled) {
  localStorage.setItem(IBCS_NAV_KEY, enabled ? 'true' : 'false');
  // Notify the nav in this tab; cross-tab syncing rides the native 'storage' event.
  window.dispatchEvent(new CustomEvent(IBCS_NAV_EVENT, { detail: { enabled } }));
}
